// Meta constants
export const META_TITLE_DEFAULT = 'Stuller'
export const META_TITLE_SHOWCASE_DEFAULT = 'Jeweler Showcase'
export const META_TITLE_POSTFIX = ` | ${META_TITLE_DEFAULT}`
export const META_TITLE_SHOWCASE_REPLACE = /( )?Stuller( )?/gi
export const META_DESCRIPTION_DEFAULT = 'Stuller, Inc. is the #1 supplier of fine jewelry, findings, mountings, tools, packaging, diamonds and gemstones for today\'s retail jeweler.'
export const META_DESCRIPTION_SHOWCASE_DEFAULT = META_TITLE_SHOWCASE_DEFAULT
